<template>
  <div class="signature" :class="{ 'state-preview' : this.theState === 'preview', 'state-editor' : this.theState === 'editor' }">

    <div v-if="this.theState === 'editor' && !payload.signatory">
      <strong>Who would you like to sign this area?</strong>
      <multiselect
        v-model="selectedSignatory"
        :options="signatories"
        placeholder="Leave This Space Empty"
        track-by="id"
        label="name"
        :searchable="false"
        :showLabels="false"
      ></multiselect>
      <a @click="waitForContact()">
        <span><span>&#x0002B;</span> {{ $t('navigation.new_contact') }}</span>
      </a>
    </div>

    <div v-if="payload.signatory">

      <!-- Edit mode -->
      <div v-if="this.theState === 'editor'">
        <ul class="metadata">
          <li><strong>Signature:</strong></li>
          <li><i class="status not-available">Not available in editing mode</i></li>
          <li><strong>Name:</strong> {{ payload.signatory.name }}</li>
          <li v-for="metadata in payload.metadata"><strong>{{ metadata.label }}:</strong> <input type="text" class="metadata-input" v-model="metadata.value" placeholder="Add title here..."></li>
          <li><strong>Date:</strong> <i>Set upon signing</i></li>
        </ul>
        <button class="button is-primary is-outlined is-small" @click="payload.signatory = false" v-if="this.theState !== 'preview' && this.theState !== 'view'">Change Signatory</button>
      </div>

      <!-- Preview mode -->
      <div v-if="this.theState === 'preview'">
        <ul class="metadata">
          <li><strong>Signature:</strong></li>
            <li><i class="status not-available">Not available in preview mode</i></li>
          <li><strong>Name:</strong> {{ payload.signatory.name }}</li>
          <li v-for="metadata in payload.metadata">
            <span v-if="metadata.label === 'Title' && metadata.value === ''"><strong>{{ metadata.label }}:</strong> N/A</span>
            <span v-else><strong>{{ metadata.label }}:</strong> {{ metadata.value }}</span>
          </li>
          <li><strong>Date:</strong> <i>Set upon signing</i></li>
        </ul>
      </div>

      <!-- View mode -->
      <div v-if="this.theState === 'view'">
        <ul class="metadata">
          <li><strong>Signature:</strong></li>
          <li v-if="isSignable"><i class="status sign-now">Sign Now</i></li>
          <li v-if="!isSignable"><i class="status pending">Pending</i></li>
          <li><strong>Name:</strong> {{ payload.signatory.name }}</li>
          <li v-for="metadata in payload.metadata">
            <span v-if="metadata.label === 'Title' && metadata.value === ''"><strong>{{ metadata.label }}:</strong> N/A</span>
            <span v-else><strong>{{ metadata.label }}:</strong> {{ metadata.value }}</span>
          </li>
          <li><strong>Date:</strong> <i>Set upon signing</i></li>
        </ul>
        <button class="button is-primary is-outlined is-small" @click="changeState('sign')" v-if="isSignable">Click Here to Sign</button>
      </div>

      <!-- Sign mode -->
      <div v-if="this.theState === 'sign'">
        <ul class="metadata">
          <li><strong>Signature:</strong></li>
          <li><input class="signature" type="text" v-model="autograph" @keyup.enter="submitSignature" placeholder="Sign here..."></li>
          <li><strong>Name:</strong> {{ payload.signatory.name }}</li>
          <li v-for="metadata in payload.metadata">
            <span v-if="metadata.label === 'Title' && metadata.value === ''"><strong>{{ metadata.label }}:</strong> N/A</span>
            <span v-else><strong>{{ metadata.label }}:</strong> {{ metadata.value }}</span>
          </li>
          <li><strong>Date:</strong> {{ new Date() | moment("dddd, MMMM Do YYYY") }}</li>
        </ul>
        <button class="button is-primary is-small" @click="submitSignature">Complete signature</button>
      </div>

      <!-- Document is signed -->
      <div v-if="this.theState === 'signed'">
        <ul class="metadata">
          <li><strong>Signature:</strong></li>
          <li class="signed">{{ this.theSignature.signature }}</li>
          <li><strong>Name:</strong> {{ payload.signatory.name }}</li>
          <li v-for="metadata in payload.metadata">
            <span v-if="metadata.label === 'Title' && metadata.value === ''"><strong>{{ metadata.label }}:</strong> N/A</span>
            <span v-else><strong>{{ metadata.label }}:</strong> {{ metadata.value }}</span>
          </li>
          <li><strong>Date:</strong> {{ this.theSignature.created_at | moment("dddd, MMMM Do YYYY") }}</li>
        </ul>
      </div>

    </div>

  </div>
</template>

<script>
  import API from 'mixins/api';
  export default {
    mixins: [API],
    props: [
      'state', 'payload', 'viewer', 'signatures'
    ],
    data() {
      return {
        Events: window.Events,
        theState: this.state,
        thePayload: this.payload,
        theSignatures: this.signatures,
        theSignature: {},
        signatories: [],
        selectedSignatory: false,
        autograph: '',
      }
    },
    beforeMount() {
      if (this.state === 'editor') {
        this.fetchSignatories();
      }

      this.Events.$on('createContact', this.fetchSignatories);
      this.Events.$on('updateContact', this.fetchSignatories);
      this.Events.$on('archiveContact', this.fetchSignatories);

      this.connectSignatures();
    },
    computed: {
      isSignable() {
        if (this.theState === 'view') {
          if (this.payload.signatory.type === 'user' && this.payload.signatory.id === window.Spark.userId) {
              return true;
          } else return this.payload.signatory.type === 'contact' && this.payload.signatory.name === this.viewer.name;
        } else {
          return false;
        }
      }
    },
    methods: {
      waitForContact() {
        this.Events.$emit('modalOpen', 'newContactModal');
        this.Events.$on('createContact', this.selectFromNewContact);
        this.Events.$on('modalClose', (modalName) => {
          if (modalName === 'newContactModal') {
            this.Events.$off('createContact', this.selectFromNewContact);
          }
        });
      },
      selectFromNewContact(contact) {
        this.Events.$off('createContact', this.selectFromNewContact);

        this.selectedSignatory = {
          type: 'contact',
          id: contact.id,
          name: contact.name
        };

        this.fetchSignatories();
      },
      changeState(newState) {
        this.theState = newState;
      },
      submitSignature() {
        let theUrl = window.location.href;
        let documentLink = theUrl.substr(theUrl.lastIndexOf('/') + 1);
        axios.post(`/api/document-link/${documentLink}`, this.theSignature)
          .then(response => {
            this.theSignature = response.data.signature;
            this.changeState('signed');
            (new Notyf()).confirm(this.$t('proposals.signed'));
            window.Events.$emit('documentSigned');
          }, function() {
            (new Notyf()).alert(this.$t('proposals.signing_error'));
          });
      },
      fetchSignatories() {
        let teamUsers = window.Spark.state.currentTeam.users;
        this.signatories = this.signatories.concat(_.map(teamUsers, user => {
          return {
            type: 'user',
            id: user.id,
            name: user.name
          }
        }));

        this.api().fetchTeamContacts().then(contacts => {
          return _.map(contacts, contact => {
            return {
              type: 'contact',
              id: contact.id,
              name: contact.name
            };
          });
        }).then(contacts => {
            this.signatories = _.sortBy(this.signatories.concat(contacts), 'name');
        });
      },
      connectSignatures() {
        if (typeof this.theSignatures !== 'undefined') {
          this.theSignatures.forEach(signature => {
            if (signature.uuid === this.thePayload.uuid) {
              this.theSignature = signature;
              this.changeState('signed');
            }
          });
        }
      }
    },
    watch: {
      selectedSignatory() {
        if (!this.payload || !this.payload.uuid) { console.warn('UUID not assigned!'); return; }
        this.$emit('update', _.extend(this.payload, { signatory: this.selectedSignatory }));
      },
      autograph() {
        this.theSignature.signature = this.autograph;
        this.theSignature.document_hash = 1;
        this.theSignature.document_id = 1;
        this.theSignature.uuid = this.thePayload.uuid;
        this.theSignature.signatory_id = this.thePayload.signatory.id;
        this.theSignature.signatory_type = this.thePayload.signatory.type;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  input.signature {
    border-bottom: 1px solid $grey;
    background-color: $white;
    font-family: "Satisfy";
    height: 43px;
    font-size: 30px;
    display: block;
    width: 100%;
    margin: 10px 0;
  }

  ul.metadata,
  ul.metadata li {
    list-style-type: none;
    margin-bottom: 3px;
    padding: 0 !important;
  }

  ul.metadata {
    li {
      i.status {
        border: 1px dashed;
        border-radius: 2px;
        padding: 10px;
        margin: 10px 0;
        display: block;
        text-align: center;
        &.not-available {
          border-color: $yellow;
          color: $yellow;
        }
        &.sign-now {
          border-color: $green;
          color: $green;
        }
        &.pending {
          border-color: $purple;
          color: $purple;
        }
      }
      &.signed {
        font-family: "Satisfy";
        height: 43px;
        font-size: 30px;
        display: block;
        width: 100%;
        margin: 10px 0;
      }
    }
  }

  .metadata-input {
    border-bottom: 1px solid $white;
    &:hover,
    &:focus {
      border-color: $mutedblue;
    }
  }

  .signature {
    div {
      div {
        .button {
          margin-top: 20px;
        }
      }
    }
    &:hover {
      cursor: pointer;
      div {
        div {
          .button {
            background: $green;
            color: $white;
            &:hover {
              background: darken($green, 10%);
            }
          }
        }
      }
    }
  }

  .signature.state-preview {
    &:hover {
      cursor: default;
    }
  }

</style>



// WEBPACK FOOTER //
// signature.vue?c8457bcc